/* jvote - Imbiss-Empfehlungs-Voting fuer /pages/bringe-jack-in-deine-nahe */
(function () {
  'use strict';

  // Stimmen-Ziel je Stadt - muss mit ACQUIRE_VOTE_THRESHOLD (PHP) uebereinstimmen.
  var VOTE_GOAL = 25;

  var API_BASE = 'https://api.my-lifestyle-food.com';

  function init() {
    var form = document.getElementById('jvote-form');
    if (!form) return;

    var placeInput = document.getElementById('jvote-place');
    var suggestBox = document.getElementById('jvote-suggest');
    var stadtInput = document.getElementById('jvote-stadt');
    var plzInput = document.getElementById('jvote-plz');
    var vornameInput = document.getElementById('jvote-vorname');
    var emailInput = document.getElementById('jvote-email');
    var consentInput = document.getElementById('jvote-consent');
    var refInput = document.getElementById('jvote-ref');
    var utmInput = document.getElementById('jvote-utm');
    var honeypot = document.getElementById('jvote-website');
    var submitBtn = document.getElementById('jvote-submit');
    var msgBox = document.getElementById('jvote-msg');
    var successBox = document.getElementById('jvote-success');
    var listEl = document.getElementById('jvote-list');
    var emptyEl = document.getElementById('jvote-empty');
    var totalVotesEl = document.getElementById('jvote-total-votes');
    var totalPlacesEl = document.getElementById('jvote-total-places');
    var sharePreLink = document.getElementById('jvote-share-pre');

    var selectedPlace = null;
    var debounceTimer = null;

    if (sharePreLink) {
      sharePreLink.addEventListener('click', function (ev) {
        ev.preventDefault();
        var url = location.href;
        var done = function () {
          var orig = sharePreLink.dataset.origText || sharePreLink.textContent;
          sharePreLink.dataset.origText = orig;
          sharePreLink.textContent = 'Link kopiert ✓';
          setTimeout(function () { sharePreLink.textContent = orig; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url, done); });
        } else {
          fallbackCopy(url, done);
        }
      });
    }

    function fallbackCopy(text, onDone) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); onDone(); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
    }

    function fetchSuggestions(query) {
      var url = 'https://photon.komoot.io/api/?q=' + encodeURIComponent(query) + '&lang=de&limit=6';
      return fetch(url).then(function (r) { return r.json(); });
    }

    function renderSuggestions(features) {
      suggestBox.innerHTML = '';
      if (!features || !features.length) {
        suggestBox.classList.remove('open');
        return;
      }
      features.forEach(function (f) {
        var p = f.properties || {};
        var name = p.name || p.street || 'Unbekannt';
        var addr = [p.housenumber, p.street].filter(Boolean).join(' ');
        var locality = [p.postcode, p.city || p.town || p.village].filter(Boolean).join(' ');
        var line2 = [addr, locality, p.country].filter(Boolean).join(' · ');
        var div = document.createElement('div');
        div.className = 'jvote-suggest-item';
        var nameEl = document.createElement('div');
        nameEl.className = 'jvote-suggest-name';
        nameEl.textContent = name;
        var addrEl = document.createElement('div');
        addrEl.className = 'jvote-suggest-addr';
        addrEl.textContent = line2;
        div.appendChild(nameEl);
        div.appendChild(addrEl);
        div.addEventListener('click', function () {
          selectedPlace = {
            name: name,
            address: addr,
            postcode: p.postcode || '',
            city: p.city || p.town || p.village || '',
            osm_id: (p.osm_type ? p.osm_type[0] : '') + (p.osm_id || ''),
            lat: f.geometry && f.geometry.coordinates ? f.geometry.coordinates[1] : null,
            lng: f.geometry && f.geometry.coordinates ? f.geometry.coordinates[0] : null
          };
          placeInput.value = name + (locality ? ', ' + locality : '');
          if (stadtInput && !stadtInput.value && selectedPlace.city) stadtInput.value = selectedPlace.city;
          if (plzInput && !plzInput.value && selectedPlace.postcode) plzInput.value = selectedPlace.postcode;
          suggestBox.classList.remove('open');
        });
        suggestBox.appendChild(div);
      });
      suggestBox.classList.add('open');
    }

    placeInput.addEventListener('input', function () {
      selectedPlace = null;
      var q = placeInput.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 3) {
        suggestBox.classList.remove('open');
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchSuggestions(q).then(function (data) {
          renderSuggestions((data && data.features) || []);
        }).catch(function () { /* silent */ });
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!suggestBox.contains(e.target) && e.target !== placeInput) {
        suggestBox.classList.remove('open');
      }
    });

    function showMsg(type, text) {
      msgBox.style.display = 'block';
      msgBox.className = 'jvote-msg ' + type;
      msgBox.textContent = text;
    }
    function hideMsg() { msgBox.style.display = 'none'; }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        if (c === '&') return '&amp;';
        if (c === '<') return '&lt;';
        if (c === '>') return '&gt;';
        if (c === '"') return '&quot;';
        return '&#39;';
      });
    }

    function showSuccess(data) {
      var pageUrl = location.href;
      var city = data.place_city || '';
      var placeName = data.place_name || '';
      var count = parseInt(data.city_vote_count, 10) || 0;
      var goal = VOTE_GOAL;
      var pct = Math.max(0, Math.min(100, Math.round(count / goal * 100)));

      // Limit erreicht: diese E-Mail hat schon fuer max. N Imbisse gestimmt ->
      // keine neue Stimme, eigene freundliche Box (ohne Fortschrittsbalken, da
      // nichts gezaehlt wurde). Teilen-CTA mit demselben #jvote-copy-Markup,
      // damit der Copy-Handler unten greift.
      if (data.limit_reached) {
        var maxN = parseInt(data.max_places, 10) || 3;
        successBox.style.display = 'block';
        successBox.innerHTML =
          '<div class="jvote-success-rank">' +
            '<h3 style="margin:0 0 8px;">Du hast schon f&uuml;r <span class="green">' + maxN + ' Imbisse</span> abgestimmt</h3>' +
            '<p class="jvote-count">Das ist das Maximum pro Person &ndash; so bleibt die Abstimmung fair. '
              + '<strong>Danke f&uuml;rs Mitmachen!</strong> Teile den Link, damit andere ihre Lieblings-Imbisse nominieren.</p>' +
            '<div class="jvote-share">' +
              '<a class="copy" href="#" id="jvote-copy">Link kopieren und Freunden helfen</a>' +
            '</div>' +
          '</div>';
        var lcBtn = document.getElementById('jvote-copy');
        if (lcBtn) {
          lcBtn.addEventListener('click', function (ev) {
            ev.preventDefault();
            var done = function () {
              lcBtn.textContent = 'Link kopiert ✓';
              setTimeout(function () { lcBtn.textContent = 'Link kopieren'; }, 2000);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(pageUrl).then(done).catch(function () { fallbackCopy(pageUrl, done); });
            } else {
              fallbackCopy(pageUrl, done);
            }
          });
        }
        return;
      }

      // "Schon abgestimmt": entweder derselbe Browser (duplicate, Cookie) oder
      // dieselbe E-Mail fuer diesen Imbiss (already_voted, server-seitig) ->
      // gleiche freundliche Ansprache.
      var alreadyVoted = data.duplicate || data.already_voted;

      // Headline mit gruenem Akzentwort (festes Markup, kein User-Input -> HTML ok).
      var headline = alreadyVoted
        ? 'Du hast f&uuml;r diesen <span class="green">Imbiss</span> schon abgestimmt'
        : 'Danke, deine <span class="green">Stimme</span> ist da!';

      // Kurze Bestaetigungszeile - nennt den Imbiss-Namen (fuer den abgestimmt
      // wurde), nicht die Stadt. Bei echtem Vote (pending) gleich die knappe
      // Handlungsaufforderung dranhaengen. Der echte Fortschritt steht am Balken.
      var countLine = '';
      if (alreadyVoted) {
        // Keine neue Stimme gezaehlt -> ehrlich formulieren + Energie aufs Teilen.
        countLine = '<p class="jvote-count">F&uuml;r '
          + (placeName ? '<strong>' + escapeHtml(placeName) + '</strong>' : 'diesen Imbiss')
          + ' z&auml;hlt pro Person eine Stimme &ndash; deine ist schon dabei. '
          + '<strong>Teile den Link, damit andere mitstimmen.</strong></p>';
      } else if (placeName) {
        countLine = '<p class="jvote-count">Deine Stimme f&uuml;r <strong>'
          + escapeHtml(placeName) + '</strong> ist da.'
          + (data.pending ? ' <strong>Jetzt nur noch schnell best&auml;tigen.</strong>' : '')
          + '</p>';
      } else if (data.pending) {
        countLine = '<p class="jvote-count">Deine Stimme ist da. '
          + '<strong>Jetzt nur noch schnell best&auml;tigen.</strong></p>';
      }

      var goalLine = 'Ab <strong>' + goal + ' Stimmen</strong> sprechen wir mit '
        + 'den Imbissen vor Ort. Jede Stimme bringt den pflanzlichen und '
        + 'proteinreichen Drehspie&szlig; n&auml;her zu dir.';

      successBox.style.display = 'block';
      successBox.innerHTML =
        '<div class="jvote-success-rank">' +
          '<h3 style="margin:0 0 8px;">' + headline + '</h3>' +
          countLine +
          '<p class="jvote-goal">' + goalLine + '</p>' +
          '<div class="jvote-progress" aria-hidden="true">' +
            '<div class="jvote-progress-bar" style="width:' + pct + '%;"></div>' +
          '</div>' +
          '<p class="jvote-progress-label">' + count + ' von ' + goal + ' Stimmen' +
            (city ? ' in ' + escapeHtml(city) : '') + '</p>' +
          '<div class="jvote-share">' +
            '<a class="copy" href="#" id="jvote-copy">Link kopieren und Freunden helfen</a>' +
          '</div>' +
        '</div>';

      var copyBtn = document.getElementById('jvote-copy');
      if (copyBtn) {
        copyBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          var done = function () {
            copyBtn.textContent = 'Link kopiert ✓';
            setTimeout(function () { copyBtn.textContent = 'Link kopieren'; }, 2000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(pageUrl).then(done).catch(function () { fallbackCopy(pageUrl, done); });
          } else {
            fallbackCopy(pageUrl, done);
          }
        });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideMsg();

      var typed = placeInput.value.trim();
      if (!typed) {
        showMsg('err', 'Bitte gib den Namen deines Lieblings-Imbiss ein.');
        placeInput.focus();
        return;
      }
      var stadt = stadtInput.value.trim();
      if (!stadt) { showMsg('err', 'Bitte gib die Stadt ein.'); stadtInput.focus(); return; }
      var vorname = vornameInput.value.trim();
      if (!vorname) { showMsg('err', 'Bitte gib deinen Vornamen ein.'); vornameInput.focus(); return; }
      var email = emailInput.value.trim();
      if (!email || !/.+@.+\..+/.test(email)) {
        showMsg('err', 'Bitte gib eine gueltige E-Mail-Adresse ein.');
        emailInput.focus();
        return;
      }
      if (consentInput && !consentInput.checked) {
        var consentWrap = consentInput.closest('.jvote-consent');
        if (consentWrap) consentWrap.classList.add('jvote-consent-error');
        showMsg('err', 'Bitte bestaetige die Einwilligung zur Speicherung deiner E-Mail-Adresse.');
        consentInput.focus();
        return;
      }
      if (consentInput) {
        var cw = consentInput.closest('.jvote-consent');
        if (cw) cw.classList.remove('jvote-consent-error');
      }

      var place = selectedPlace || { name: typed };
      var finalCity = stadt || place.city || '';
      var finalPlz = plzInput.value.trim() || place.postcode || '';

      var payload = {
        place_name: place.name,
        place_address: place.address || '',
        place_postcode: finalPlz,
        place_city: finalCity,
        place_osm_id: place.osm_id || '',
        place_lat: place.lat || null,
        place_lng: place.lng || null,
        vorname: vorname,
        email: email,
        website: honeypot.value || '',
        ref: (refInput && refInput.value) || '',
        utm_source: (utmInput && utmInput.value) || ''
      };

      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet…';

      // Hinweis: KEIN credentials:'include'. Der Vote-Endpoint braucht keine
      // Cookies (oeffentliche DOI-Abstimmung), und credentials:'include' bei
      // einem Cross-Origin-Request wird von eingeschraenkten In-App-Browsern
      // (WhatsApp/Instagram) haeufig blockiert -> war die wahrscheinliche
      // Ursache des sporadischen "Fehler (404)".
      function postVote() {
        return fetch(API_BASE + '/vote.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          return r.json().catch(function () { return null; }).then(function (d) {
            return { ok: r.ok, status: r.status, data: d };
          });
        });
      }

      function finish() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Meinen Lieblings-Imbiss vorschlagen';
      }

      function handle(res) {
        finish();
        if (res.ok && res.data && res.data.success) {
          placeInput.value = '';
          stadtInput.value = '';
          plzInput.value = '';
          vornameInput.value = '';
          emailInput.value = '';
          if (consentInput) consentInput.checked = false;
          selectedPlace = null;
          // Untere Pre-Submit-Box ausblenden (doppelt mit Erfolgs-Box)
          var preShareBox = document.querySelector('.jvote-share-inline');
          if (preShareBox) preShareBox.style.display = 'none';
          showSuccess(res.data);
          loadRanking();
        } else {
          // Bei serverseitigem Fehler nutzen wir die Server-Nachricht; sonst
          // eine sprechende Meldung statt eines nackten Status-Codes.
          var err = (res.data && res.data.error) ||
            'Das hat gerade nicht geklappt. Bitte versuche es in einem Moment noch einmal.';
          showMsg('err', err);
        }
      }

      // Ein stiller Retry bei Netzwerk-/Verbindungsfehlern (kein Server-Antwort-Fehler).
      postVote()
        .then(handle)
        .catch(function () {
          postVote()
            .then(handle)
            .catch(function () {
              finish();
              showMsg('err', 'Verbindung zum Server fehlgeschlagen. Bitte pruefe deine Internetverbindung und versuche es erneut.');
            });
        });
    });

    function loadRanking() {
      fetch(API_BASE + '/ranking.php?limit=10', { method: 'GET' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data) return;
          totalVotesEl.textContent = (data.total_votes || 0).toLocaleString('de-DE');
          totalPlacesEl.textContent = (data.total_places || 0).toLocaleString('de-DE');
          var top = data.top || [];
          if (!top.length) {
            listEl.innerHTML = '';
            emptyEl.style.display = 'block';
            return;
          }
          emptyEl.style.display = 'none';
          listEl.innerHTML = top.map(function (p) {
            var rankCls = p.rank === 1 ? 'top1' : (p.rank === 2 ? 'top2' : (p.rank === 3 ? 'top3' : ''));
            var votesLbl = p.votes === 1 ? 'Stimme' : 'Stimmen';
            return '<li class="' + rankCls + '">'
                 + '<span class="rank">' + p.rank + '</span>'
                 + '<span class="info">'
                   + '<span class="nm">' + escapeHtml(p.name) + '</span>'
                   + (p.city ? '<span class="ct">' + escapeHtml(p.city) + '</span>' : '')
                 + '</span>'
                 + '<span class="vts">' + p.votes + ' <small>' + votesLbl + '</small></span>'
                 + '</li>';
          }).join('');
        })
        .catch(function () { /* silent */ });
    }

    loadRanking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
